import React, { useState } from 'react';

import { getColors } from '@styles/colorsTheme';
import { CloseOutlined } from '@material-ui/icons';
import Selo from '@assets/Login/osid-vertical.png';

import { Grid } from '@material-ui/core';
import '@styles/AntStyles.css';
import { addDays } from 'date-fns';
import { useTheme, useMediaQuery } from '@material-ui/core';

const Termo: React.FC = () => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


  function handleModalClose() {
    window.location.reload();
  }



  return (
    <>
      <Grid container>

        {/* ------------------- BACKGROUND ----------------------- */}
        <Grid
      container
      item
      lg={12}
      sm={12}
      xs={12}
      style={{
        backgroundColor: '#0085be',
        backgroundImage: isMobile
          ? 'none'
          : `url('https://amex-osid.s3.sa-east-1.amazonaws.com/osid-aqsm-img_2.png')`,
        backgroundSize: '30%',
        backgroundPosition: 'left bottom',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}
    >

<div
    style={{
      position: 'absolute',
      inset: '0',
      pointerEvents: 'none',
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.7' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
      opacity: 0.08,
      animation: 'grainMove 8s steps(10) infinite',
      zIndex: 0,
    }}
  />



            {/* ----------------------------- ETAPA 0 (PRIMEIRA PÁGINA) --------------------*/}


              <Grid container item lg={12} sm={12} xs={12} style={{marginTop: 103, marginBottom: 50}}>

                <Grid container item lg={12} sm={12} xs={12}>
                  <Grid  container item lg={4} sm={4} xs={12} justify="center" style={{marginLeft: 20}}></Grid>

                  <Grid  container item lg={4} sm={4} xs={12} justify="center"  style={{marginLeft: 5, marginRight: 5, backgroundColor:'#1261a2',}}>

                    <Grid  container item lg={12} sm={12} xs={12} justify='flex-end' style={{textAlign:'end', marginRight: 5,}}>
                      <button
                        style={{marginTop: 10,  }}
                        onClick={() => {
                          handleModalClose();
                        }}
                      >
                        <CloseOutlined
                          fontSize="medium"
                          htmlColor={getColors()?.azulEscuro}
                        />
                      </button>
                    </Grid>

                    <Grid  container item lg={12} sm={12} xs={12} justify="center">
                      <img src={'https://amex-osid.s3.sa-east-1.amazonaws.com/osid-aqsm-logo_1_parafundoazul.png'}  style={{ height: 145, width: 110}} />
                    </Grid>

                    <Grid  container item lg={2} sm={2} xs={12} justify="center"></Grid>

                    <Grid  container item lg={8} sm={8} xs={12} justify="center">

                      <p style={{textAlign:'start', color:'#ebc465', fontWeight: 900, fontSize: '19px', marginTop: 20}}>
                        Bem vindo(a) ao programa Sócio Protetor!
                      </p>
                      <p style={{textAlign:'start', color:'#ebc465', fontWeight: 900, fontSize: '19px', marginTop: 2}}>
                      Através de pessoas como você, seguimos mantendo vivo o legado de Amar e Servir.
                      </p>
                      <p style={{textAlign:'start', color:'#ebc465', fontWeight: 900, fontSize: '19px', marginTop: 2}}>
                      As Obras Sociais Irmã Dulce agradecem sua doação.
                      </p>


                      <p style={{textAlign:'start', color:'#ebc465', fontSize: '11px', marginTop: 60, marginBottom: 70}}>


                      </p>
                    </Grid>

                    <Grid  container item lg={2} sm={2} xs={12} justify="center"></Grid>

                  </Grid>

                  <Grid  container item lg={4} sm={4} xs={12} justify="center"></Grid>
                </Grid>
              </Grid>
        </Grid> {/* background */}

      </Grid>



    </>
  );
};

export default Termo;
